import React, { Component } from 'react';
import {
    Card,
    CardHeader,
    CardBody,
    Input,
    Button,
    CardFooter,
    CardTitle,
    Row,
    Col
} from "reactstrap";
import { Label } from '../../components/UI/Form/Label/Label';
import DatePicker from "react-datepicker";
import Select from 'react-select';

import Toaster from '../../components/UI/Toaster/Toaster';
import OrderCard from '../../components/OrderCard/OrderCard.jsx';
import { ToastContainer, toast } from 'react-toastify';
import {
    TableContainer,
    Table,
    TableHead,
    TableBody,
    IconButton,
    TableRow,
    TableCell,
    Collapse,
    Paper
} from '@material-ui/core';

import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import Moment from 'react-moment';
import { TakeThisOrder } from '../../api/index';
import 'moment/locale/id';
import moment from 'moment';




import { ListOrder, ConfirmSend, ListStatus, DeclineThisOrder } from '../../api/index';


class OrderListToDeliver extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isFetching: false,
            selectBy: { id: 2, value: 'Jumlah Transfer', label: 'Jumlah Transfer' },
            selectByOptions: [
                { id: 1, value: 'Nomor Invoice', label: 'Nomor Invoice' },
                { id: 2, value: 'Jumlah Transfer', label: 'Jumlah Transfer' },
            ],
            // paymentDate: new Date(),
            value: null,
            startDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
            endDate: new Date(new Date().setHours(23, 59, 59, 999)),
            count: 0,
            dataListOrder: null,
            sumsubtotal:null,
            totalcustomer:null,
            totalbriedc:null,
            totalbriqr:null,
            totalarthaqr:null,
            totalcash:null,
            listStatus: [],
            currentStatus: {
                id: 2,
                statusName: "Transaksi Berhasil"
            },
            sortby: [
                {
                  id:1,
                  value:"1",
                  label:"BRI EDC"
                },
                {
                  id:2,
                  value:"2",
                  label:"BRI QRIS"
                },
                {
                  id:3,
                  value:"3",
                  label:"ARTHA QRIS"
                },
                {
                  id:4,
                  value:"4",
                  label:"CASH"
                }
              ],

        }
    }

    formatuang(amount) {
        if (amount === null) {
            amount = 0;
        }
        // deletecomma
        let comadel = amount.toString().replace(/\,/g, '');
        let price = comadel.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");;
        return price;
    }

    onChangeMoneyHandler = (event) => {

        // validasi input tidak boleh huruf
        let values = event.target.value.toString().replace(/\,/g, '');

        // let isNum = /^\d+$/.test(values); // tanpakoma
        let isNum = /^[0-9]+\.?[0-9]*$/.test(values); // dengan koma output true or false                 

        let key = event.target.name;
        if (isNum || event.target.value === null) {
            this.setState({ [key]: parseInt(values) })
        }
        else if (values.length <= 1) {
            this.setState({ [key]: parseInt(0) })
        }

    }

    fetchOrderCard = () => {
        this.setState({ isFetching: true })


        const date = moment(this.state.startDate).format('YYYY-MM-DD'); ;
        const dateEnd = moment(this.state.endDate).format('YYYY-M-DD');;
        console.log(date)

        const dateTimeStart = date + " 00:00:00";
        const dateTimeEnd = dateEnd + " 23:59:59";



        const content = {
            querysearch: this.state.value,
            startDate: dateTimeStart,
            endDate: dateTimeEnd,
            statusId: [this.state.currentStatus.id],
            page: 1
        }



        ListOrder(content).then(result => {

            this.setState({ dataListOrder: result.result, isFetching: false, count: result.result.length, sumsubtotal: result.subtotal[0].total, totalcustomer: result.subtotal[0].total_customer,
            totalbriedc:result.edc[0].total, totalbriqr:result.briqr[0].total, totalarthaqr:result.arthaqr[0].total, totalcash:result.cash[0].total });
             console.log(result.subtotal[0].total)
        })
    }


    // status pengiriman
    fetchListStatus = () => {
        this.setState({ isFetching: true });

        const date = moment(this.state.startDate).format('YYYY-MM-DD'); ;
        const dateEnd = moment(this.state.endDate).format('YYYY-M-DD');;
        console.log(date)

        const dateTimeStart = date + " 00:00:00";
        const dateTimeEnd = dateEnd + " 23:59:59";

        const content = {
            querysearch: this.state.value,
            startDate: dateTimeStart,
            endDate: dateTimeEnd,
        };

        ListStatus(content).then(result => {
            this.setState({ listStatus: result.data });
        })
    }

    queryInputChangeHandler = (event) => {
        event.preventDefault();
        this.setState({ value: event.target.value, dataListOrder: null }, () => {
            this.fetchOrderCard();
            this.fetchListStatus();
        })

    }

    handleChangeStart = (val) => {
        this.setState({ startDate: val, dataListOrder: null }, () => {
            this.fetchOrderCard();
            this.fetchListStatus();
        })
    }

    handleChangeEnd = (val) => {
        this.setState({ endDate: val, dataListOrder: null }, () => {
            this.fetchOrderCard();
            this.fetchListStatus();
        })
    }

    handleStatusClick = (e, value) => {
        this.setState({ currentStatus: value, dataListOrder: null }, () => {
            this.fetchOrderCard();
            this.fetchListStatus();
        });
    }

    componentDidMount() {
        this.fetchOrderCard();
        this.fetchListStatus();
    }

    DeclineItHandler = (e, invNumber) => {
        e.stopPropagation();
        this.setState({ dataListOrder: null });
        const content = {
            invoiceNumber: invNumber
        }
        DeclineThisOrder(content).then(result => {
            toast.success("Order Dibatalkan 👍🏻" + result.data.prosesBy);
            this.fetchOrderCard();
            this.fetchListStatus();

        }).catch(err => {
            console.log(err)
        })
    }


    takeItHandler = (e, invNumber) => {
        e.stopPropagation();
        const content = {
            invoiceNumber: invNumber
        }
        TakeThisOrder(content).then(result => {
            this.setState((prevState) => ({
                data: {
                    ...prevState.data,
                    prosesBy: result.data.prosesBy,
                    dateproses: result.data.dateproses
                }
            }))

            this.fetchOrderCard();
            this.fetchListStatus();
            toast.success("Selamat bertugas 👍🏻" + result.data.prosesBy + " Segera input nomor resi jika sudah mengirimkannya");
        }).catch(err => {
            console.log(err)
        })
    }

    renderTable = () => {
        const Row = (props) => {
            const { data } = props;
            const [open, setOpen] = React.useState(false);
            let ButtonCondition = null;

            // if (data.prosesBy !== null && data.no_resi == null) {
            //     ButtonCondition = <small><strong>Diproses : </strong>{data.prosesBy} <br></br> <Moment fromNow>{data.dateproses}</Moment></small>
            // } else if (data.status > 1 && data.status < 5 && data.prosesBy == null && data.no_resi == null) {
            //     ButtonCondition = <Button onClick={(e) => this.takeItHandler(e, data.invoiceNumber)} style={{ margin: '0', width: '100%', borderRadius: '0px' }} size="lg" className="take-it-background">PROSES</Button>;
            // } else if (data.status === 1 && new Date(data.expireDate) > new Date()) {
            //     ButtonCondition = <div style={{ marginLeft: '10px', textAlign: 'center' }}>Batas Pembayaran : <Moment fromNow>{data.expireDate}</Moment></div>;
            // } 
            // else if (data.status === 1 && new Date(data.expireDate) < new Date()) {
            //     ButtonCondition = <Button onClick={(e) => this.DeclineItHandler(e, data.invoiceNumber)} style={{ margin: '0', borderRadius: '0px' }} size="lg" className="take-it-background">BATAL</Button>;
            // } 
            // else if (data.status === 5) {
            //     ButtonCondition = <span>Waktu tenggat pembayaran sudah habis</span>
            // }
            // else {
            //     ButtonCondition = data.no_resi;
            // }

            return <>
                <TableRow onClick={() => setOpen(!open)}>
                    <TableCell>
                        <IconButton aria-label="expand row" size="small" onClick={() => setOpen(!open)}>
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell>{data.invoiceNumber}</TableCell>
                    {/* <TableCell>{data.Customer.email}</TableCell> */}
                    {/* <TableCell>{data.courier}</TableCell> */}
                    <TableCell> <Button size="sm" style={{ margin: '0', borderRadius: '23px', background: data.StatusOrder.color }}>{data.StatusOrder.statusName}</Button></TableCell>
                    <TableCell style={{textAlign:'right'}}>{this.formatuang(data.subtotal)}</TableCell>
                    {/* <TableCell>{ButtonCondition}</TableCell> */}
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                        <OrderCard DeclineItHandler={this.DeclineItHandler} history={this.props.history} OrderProps={data}></OrderCard>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </>
        }
        const rows = this.state.dataListOrder.map((value, index) => {            
            return <Row key={index} data={value}></Row>
        })



        return (<TableContainer component={Paper}>
            <Table aria-label="collapsible table">
                <TableHead>
                    <TableRow>
                        <TableCell />
                        <TableCell>Invoice</TableCell>
                        <TableCell>Status</TableCell>
                        {/* <TableCell></TableCell> */}
                        <TableCell></TableCell>

                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows}
                </TableBody>
            
            <TableHead>
            <TableRow>
            <TableCell />
            <TableCell></TableCell>
            <TableCell>SUB TOTAL </TableCell>
            <TableCell> {this.formatuang(this.state.sumsubtotal)}</TableCell>

                </TableRow>
                

                
                
            </TableHead>

            </Table>
        </TableContainer>)
        
    }


    render() {
        let listorder = <>
            <div className="loading-background" style={{ width: '100%', height: '40px', marginTop: '10px' }}></div>
            <div className="loading-background" style={{ width: '100%', height: '40px', marginTop: '10px' }}></div>
            <div className="loading-background" style={{ width: '100%', height: '40px', marginTop: '10px' }}></div>
        </>

        if (this.state.dataListOrder !== null) {
            listorder = this.renderTable()
            // listorder = this.state.dataListOrder.map((value, index) =>
            //     ("")
            //     // (<OrderCard DeclineItHandler={this.DeclineItHandler} history={this.props.history} OrderProps={value} key={index}></OrderCard>)
            // )
        }

        let listStatus = this.state.listStatus.map((value, index) => (
            <div key={index} onClick={(e) => this.handleStatusClick(e, value)} className={this.state.currentStatus.id === value.id ? "card-status-btn active-status" : "card-status-btn"} >
                Sub Total <span className="card-count-wrapper" style={{ background: `orange` }}>{this.formatuang(this.state.sumsubtotal)} </span> ...
                Total Customer <span className="card-count-wrapper" style={{ background: `black` }}>{this.formatuang(this.state.totalcustomer)}</span>...
                BRI EDC <span className="card-count-wrapper" style={{ background: `${value.color}` }}>{this.formatuang(this.state.totalbriedc)}</span>...
                BRI QR <span className="card-count-wrapper" style={{ background: `purple` }}>{this.formatuang(this.state.totalbriqr)}</span>...
                ARTHA QR <span className="card-count-wrapper" style={{ background: `red` }}>{this.formatuang(this.state.totalarthaqr)}</span>...
                CASH <span className="card-count-wrapper" style={{ background: `green` }}>{this.formatuang(this.state.totalcash)}</span>...
            </div>
            
        ));
        

        return (
            <>
                <ToastContainer />
                <div className="content">
                    <div className="otd-wrapper">
                        <div className="otd-header-wrapper">
                           
                            {/* <div className="count"><span className="count-title">Count :</span> {this.state.count}</div> */}

                            

                            <div className="date-input-filter">
                                <label style={{ padding: '0px 10px' }}><i className="nc-icon nc-calendar-60" /></label>
                                <DatePicker
                                    className="form-control datepicker-input"
                                    selected={this.state.startDate}
                                    dateFormat="dd-MM-yyyy"
                                    selectsStart
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    onChange={(val) => this.handleChangeStart(val)}
                                />
                                <span style={{ padding: '0px 10px' }}>-</span>
                                <DatePicker
                                    className="form-control datepicker-input"
                                    selected={this.state.endDate}
                                    dateFormat="dd-MM-yyyy"
                                    selectsEnd
                                    startDate={this.state.startDate}
                                    endDate={this.state.endDate}
                                    onChange={(val) => this.handleChangeEnd(val)}
                                />
                            </div>
                            <div className="search-input-wrap">
                                <Input onChange={(event) => { this.queryInputChangeHandler(event) }} placeholder="1 = BRI ED, 2 = BRI QR, 3 = ARTHA QR, 4 = CASH"></Input>
                            </div>

                            {/* <div className="count">
                            <Select
                            onChange={(val) => this.qu(val)
                            }
                            name="sortby"
                            placeholder="Pilih Bank"                  
                            // value={this.state.sortbySelect}
                            className="basic-multi-select"
                            options={this.state.sortby}
                            />
                        </div> */}

                        </div>
                        <div className="list-status-class">
                            {listStatus}

                        </div>
                        {listorder}
                    </div>


                </div>
            </>
        )
    }
}

export default OrderListToDeliver;